module.exports = "<span (click)=\"toggleShortcodeCheatsheet()\">{{ show ? 'Hide' : 'Show' }} Shortcode Cheatsheet</span>\n"